// Local translations
export const T = {
  en_GB: {
    searchComponents: "Search components...",
    noComponentsFound: "No components found",
    requirements: "Requirements:",
    goalPagesOnly: "Can only be used on goal pages",
    globalPagesOnly: "Can only be used on global pages",
    portfolioPagesOnly: "Can only be used on the portfolio page",
    requiresRiskModel: "Requires risk model to be configured on the flow",
    requiresPortfolioCollection: "Requires portfolio collection to be configured on the flow",
    requiresXRay: "Requires Morningstar X-Ray access",
    requiresAssetAllocationSetting:
      'Enable the collection\'s "Requires asset allocation" setting to use this component',
    requiresTimeseriesSetting:
      'Enable the collection\'s "Requires timeseries" setting to use this component',
    trapetsDisabledBlock: "Enable Trapets in settings to use this component",
    sumsubDisabledBlock: "Enable Sumsub in settings to use this component",
    selectComponentDetails: "Select a component type to see details",
    riskShowsHere: "Shows here:",
    riskShowsNothing:
      "This flow's risk model captures every risk input on the other page type, so this placement would show nothing",
    riskSectionTimeHorizon: "time horizon",
    riskSectionRiskLevel: "risk tolerance",
    riskSectionAdjustmentQuestions: "knowledge and experience questions",
    riskSectionResult: "result (score and level)",
  },
  nb_NO: {
    searchComponents: "Søk etter komponenter...",
    noComponentsFound: "Ingen komponenter funnet",
    requirements: "Krav:",
    goalPagesOnly: "Kan kun brukes på målsider",
    globalPagesOnly: "Kan kun brukes på globale sider",
    portfolioPagesOnly: "Kan kun brukes på porteføljesiden",
    requiresRiskModel: "Krever at risikomodell er konfigurert på flyten",
    requiresPortfolioCollection: "Krever at porteføljesamling er konfigurert på flyten",
    requiresXRay: "Krever Morningstar X-Ray-tilgang",
    requiresAssetAllocationSetting:
      'Aktiver samlingens "Krever aktivaallokering"-innstilling for å bruke denne komponenten',
    requiresTimeseriesSetting:
      'Aktiver samlingens "Krever tidsserie"-innstilling for å bruke denne komponenten',
    trapetsDisabledBlock: "Aktiver Trapets i innstillingene for å bruke denne komponenten",
    sumsubDisabledBlock: "Aktiver Sumsub i innstillingene for å bruke denne komponenten",
    selectComponentDetails: "Velg en komponenttype for å se detaljer",
    riskShowsHere: "Vises her:",
    riskShowsNothing:
      "Risikomodellen til denne flyten fanger alle risikoinnspill på den andre sidetypen, så denne plasseringen ville ikke vist noe",
    riskSectionTimeHorizon: "tidshorisont",
    riskSectionRiskLevel: "risikotoleranse",
    riskSectionAdjustmentQuestions: "kunnskaps- og erfaringsspørsmål",
    riskSectionResult: "resultat (skår og nivå)",
  },
} as const;
